import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import { HazardProfileForm } from 'common/forms';
import { HazardProfileFormValues } from 'common/models/Forms';

import { QuestionTitle, PageControls } from '../../../../components';
import { selectInvestingHazard, setInvestingHazardValuesAction } from '../../../../ducks';
import { useFormStepContinueRef } from '../../../../hooks/useFormStepContinueRef';
import { FeatureProps } from '../../../../index';

export default function InvestingHazardFeature({ isPrivileged }: FeatureProps) {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = useSelector(selectInvestingHazard);

  const { bindFormik, continueWithSoftValidation, showSoftContinueHint } =
    useFormStepContinueRef<HazardProfileFormValues>();

  function handleBackClick() {
    navigate(-1);
  }

  async function handleContinueClick() {
    await continueWithSoftValidation((values) => {
      handleSubmit(values);
    });
  }

  function bindSubmit(formik: FormikProps<HazardProfileFormValues>) {
    bindFormik(formik);
  }

  function handleSubmit(values: HazardProfileFormValues) {
    if (!isPrivileged) {
      dispatch(setInvestingHazardValuesAction(values));
    }
    navigate(`/form/${id}/investing/finances`);
  }

  return (
    <>
      <QuestionTitle prefix="II.">{t('investingFeature.hazard')}</QuestionTitle>
      <HazardProfileForm initialValues={initialValues || undefined} bindSubmit={bindSubmit} onSubmit={handleSubmit} />
      <PageControls softContinueHint={showSoftContinueHint} onBack={handleBackClick} onContinue={handleContinueClick} />
    </>
  );
}
